export const LOBBY_UI = {
  teamLabels: ['Blue', 'Red'] as const,
  teamInk: ['#8098ff', '#ff7263'] as const,
  portrait: 34,
  emptyList: 'No public lobbies. Create one.',
  noMatch: 'No lobby matches that search.',
  refreshMs: 5000,
} as const;
